import { render, staticRenderFns } from "./ColumnFormatting.vue?vue&type=template&id=2dc56161&scoped=true&"
import script from "./ColumnFormatting.vue?vue&type=script&lang=ts&"
export * from "./ColumnFormatting.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnFormatting.vue?vue&type=style&index=0&id=2dc56161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc56161",
  null
  
)

export default component.exports